import { Device } from '../../types';

export interface ListDeviceState {
  devices: Device[];
  filteredDevices: Device[];
  searchTerm: string;
  loading: boolean;
  error: string | null;
  selectedDevice: Device | null;
}

const initialState: ListDeviceState = {
  devices: [],
  filteredDevices: [],
  searchTerm: '',
  loading: false,
  error: null,
  selectedDevice: null,
};

export enum DeviceActionTypes {
  LIST_DEVICE_REQUEST = 'LIST_DEVICE_REQUEST',
  LIST_DEVICE_SUCCESS = 'LIST_DEVICE_SUCCESS',
  LIST_DEVICE_FAILURE = 'LIST_DEVICE_FAILURE',
  SEARCH_DEVICES = 'SEARCH_DEVICES',
  SELECT_DEVICE = 'SELECT_DEVICE',
}

const listDeviceReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case DeviceActionTypes.LIST_DEVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DeviceActionTypes.LIST_DEVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        devices: action.payload,
        filteredDevices: action.payload,
      };
    case DeviceActionTypes.LIST_DEVICE_FAILURE:
      console.log('List device failure');
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DeviceActionTypes.SEARCH_DEVICES:
      const searchTerm = action.payload.toLowerCase();
      const filteredDevices = state.devices.filter((device) => {
        return (
          device.address.toLowerCase().includes(searchTerm) ||
          device.paymentService.toLowerCase().includes(searchTerm) ||
          (device.comment && device.comment.toLowerCase().includes(searchTerm))
        );
      });
      return {
        ...state,
        searchTerm,
        filteredDevices,
      };
    case DeviceActionTypes.SELECT_DEVICE:
      return {
        ...state,
        selectedDevice: action.payload ? { ...action.payload } : null,
      };
    default:
      return state;
  }
};

export default listDeviceReducer;
